const API_URL = process.env.REACT_APP_API_URL || '';
const FILE_ACCESS_URL = process.env.REACT_APP_FILE_ACCESS || '';

console.log('API_URL from env:', API_URL);
console.log('FILE_ACCESS_URL from env:', FILE_ACCESS_URL);

if (!API_URL) {
  console.warn('⚠️ REACT_APP_API_URL is not set in environment variables!');
}

const CUSTOM_INPUT_TYPES = [
  "text-input",
  "number-input",
  "multiline-text-input",
  "email-input",
  "select",
  "multi-select",
  "checkbox",
  "multi-checkbox",
  "date-picker",
  "datetime-picker",
];

export { API_URL, FILE_ACCESS_URL, CUSTOM_INPUT_TYPES };
